import { OBLIGATION_ENUM } from './OBLIGATION_ENUM'

export const DATA_TYPE_DEPENDENT_OBLIGATION_OPTIONS = [
  { id: OBLIGATION_ENUM.UPDATE_AS_HASHED, name: 'Hash' },
  { id: OBLIGATION_ENUM.UPDATE_AS_MASKED, name: 'Mask' },
]
